import { PlaybookReportType } from '@driftt/api-types'
import { pathOr } from 'ramda'

import { ALL_CHAT_PLAYBOOK_TYPES } from 'constants/types'

import rowFormatter from './rowFormatter'

export const bucketPlaybooksByType = (playbooks = []) => {
  const abmPlaybooks = []
  const abmPlaybookIds = []
  const nonSpecialPlaybooks = []
  const nonSpecialPlaybookIds = []
  const outboundPlaybooks = []
  const outboundPlaybookIds = []

  for (let i = 0, len = playbooks.length; i < len; i++) {
    const current = playbooks[i] || {}
    const id = pathOr(null, ['id'], current)
    const reportType = pathOr(null, ['reportType'], current)

    if (reportType === PlaybookReportType.ABM) {
      abmPlaybookIds.push(id)
      abmPlaybooks.push(current)
    } else if (
      reportType === PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS
    ) {
      outboundPlaybookIds.push(id)
      outboundPlaybooks.push(current)
    } else if (
      ALL_CHAT_PLAYBOOK_TYPES.includes(reportType) ||
      'MEETING_BOOKING_BOT'
    ) {
      nonSpecialPlaybookIds.push(id)
      nonSpecialPlaybooks.push(current)
    }
  }

  return {
    idPriorityList: [
      ...outboundPlaybookIds,
      ...abmPlaybookIds,
      ...nonSpecialPlaybookIds,
    ],
    playbookTypes: {
      ABM: abmPlaybooks,
      nonSpecial: nonSpecialPlaybooks,
      outbound: outboundPlaybooks,
    },
  }
}

export const getColumns = (showWorkspaceColumn) => {
  const workspaceLabel = {
    label: 'Workspace',
    width: '80px',
  }

  const maybeWorkspaceColumn = showWorkspaceColumn ? [workspaceLabel] : []

  return [
    {
      label: 'Priority',
      width: '80px',
    },
    {
      label: 'Playbook',
      width: '250px',
    },
    ...maybeWorkspaceColumn,
    {
      label: 'Status',
      width: '72px',
    },
    {
      label: 'Type',
      width: '116px',
    },
    {
      label: 'Last updated',
      width: '80px',
    },
    {
      label: 'Updated by',
      width: '120px',
    },
    {
      label: null,
      width: '180px',
    },
  ]
}

export const makeRows = ({
  showWorkspaceColumn,
  allWorkspaces,
  changePriority,
  orgUsers,
  priorityPayload = {},
}) => {
  const { idPriorityList, playbookTypes } = priorityPayload

  const abmPlaybooks = pathOr([], ['ABM'], playbookTypes)
  const nonSpecialPlaybooks = pathOr([], ['nonSpecial'], playbookTypes)
  const outboundPlaybooks = pathOr([], ['outbound'], playbookTypes)

  const dataForProcessing = [
    {
      playbooks: outboundPlaybooks,
      type: 'OUTBOUND',
    },
    {
      playbooks: abmPlaybooks,
      type: 'ABM',
      offset: outboundPlaybooks.length,
    },
    {
      playbooks: nonSpecialPlaybooks,
      type: 'NON_SPECIAL',
      offset: outboundPlaybooks.length + abmPlaybooks.length,
    },
  ]

  const rowData = []

  for (let i = 0, len = idPriorityList.length; i < len; i++) {
    const id = idPriorityList[i] || null

    for (let j = 0, len2 = dataForProcessing.length; j < len2; j++) {
      const currentSetOfPlaybooks = dataForProcessing[j] || {}
      const offset = currentSetOfPlaybooks.offset || 0
      const playbooks = currentSetOfPlaybooks.playbooks || []
      const playbookType = currentSetOfPlaybooks.type || null

      const currentPb = playbooks.find((playbook) => id === playbook.id)

      if (!currentPb) {
        continue
      }

      rowData.push({
        data: rowFormatter({
          offset,
          onChange: changePriority,
          orgUsers,
          playbook: { ...currentPb, priority: i + 1 },
          playbookType,
          totalPlaybooks: playbooks.length,
          allWorkspaces,
          showWorkspaceColumn,
        }),
      })
    }
  }

  return rowData
}
